import {MATRIX_URL_SUFFIX} from '@/services/matrix/client/constants';

const AliasRegexp = new RegExp(
  `^#([^~]+):${MATRIX_URL_SUFFIX.replace(/([.])/g, '\\$1')}$`
);
export const getDocumentIdFromAlias = (alias: string): string | null => {
  const m = alias.match(AliasRegexp);
  if (m) {
    return m[1];
  }
  return null;
};
